<template>
  <div class="treeTableContainer1">
    <div class="top">
      <span class="per">安装人列表：</span>
      <button class="primaryBtn" @click="searchAlco1">搜索</button>
      <el-input class="ipt" placeholder="请输入昵称" v-model="searchText1" style="width:200px;"></el-input>
    </div>
    <div class="treeTableTbody">
      <el-table class="borderTable"
        border ref="elderTable1" 
        :data="modulesData1" style="width:100%" v-loading="loading1"
        @selection-change="selectionTableDtaChange1" :row-key="getRowKeys1">
        <el-table-column type="selection" align="center" width="50" :reserve-selection="true"></el-table-column>
        <el-table-column prop="nickName" label="昵称"></el-table-column>
        <el-table-column label="登录名">
          <template slot-scope="scope">{{ scope.row.loginName }}</template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pageWrap" v-if="pages1.show && modulesData1.length">
      <el-pagination background @size-change="handleSizeChange1" @current-change="handleCurrentChange1"
        :current-page="pages1.currentPage" :page-sizes="pageSizes1" :page-size="pages1.pageSize"
        :pager-count="pagerCount" :layout="pageLayout" :total="pages1.total"></el-pagination>
    </div>
  </div>
</template>

<script>
  export default {
    props: ["modulesData1", "treeTableLabel", "isEdit", "sendTreeData1", "pages1", "pageSizes1", "loading1"],
    data() {
      return {
        pageLayout: 'total, sizes, prev, pager, next, jumper',
        pagerCount: 5,
        secltableData1:[],//回显(所有选中状态)
        secltId1: [], //所有选中id
        elderData1: [],//表格数据
        checkData1:[],
        searchText1:''
      };
    },
    watch: {
      modulesData1(newValue, oldValue) {
        // console.log(newValue)
      },
      sendTreeData1(newValue, oldValue) {
        this.$refs.elderTable1.clearSelection()
        // console.log(newValue)
        // console.log(this.modulesData1);
        this.checkData1=newValue
        this.secltableData1=this.checkData1
        this.secltDatas = []
        // for (let selectedItem of this.checkData1) {
          // this.secltId1.push(selectedItem.id)
          // this.$refs.elderTable1.toggleRowSelection(selectedItem, true)
        // }
        // console.log(this.secltId1);
        // this.$emit("sendCheckNode1", this.secltId1)

        // js 删除两个数组中id相同的对象
        let arr1 = this.modulesData1
        let arr2 = this.secltableData1
        //ES6的方法
        let add = arr2.filter(item => !arr1.some(ele=>ele.id===item.id));
        // console.log(add);
        this.elderData1 = this.modulesData1
        this.$nextTick(() => {
          this.showSeclectRow1()
        })
        add.forEach(items=>{
          this.$nextTick(() => {
            this.$refs.elderTable1.toggleRowSelection(items, true)
          })
        })
      }
    },

    mounted() {},
    created(){},
    methods: {
      searchAlco1(){
        this.$emit('nickName1',this.searchText1)
      },
      handleSizeChange1(val) { //pageSize变化时函数
        this.$emit('sizeChange1', val)
      },
      handleCurrentChange1(val) { //当前页变化时函数
        this.$emit('currentChange1', val)
      },
      //记录翻页选中
      getRowKeys1(row) {
        return row.id
      },
      unique(arr) {
        const res = new Map();
        return arr.filter((arr) => !res.has(arr.id) && res.set(arr.id, 1));
      },
      // 选择的表单（对选中数据处理，需要处理数据，用于传递给后台）
      selectionTableDtaChange1 (selection) {
        // console.log(selection);
        this.secltableData1 = selection 
        // 去重获取被选中的id值存入到数组中
        this.secltId1 = []
        for (let selectedItem of selection) {
          this.secltId1.push(selectedItem.id)
        }
        // console.log(this.secltId1);
        this.$emit("sendCheckNode1", this.secltId1)
      },
      //回显
      showSeclectRow1 () {
        // console.log(this.secltableData1);
        if (this.secltableData1.length > 0) {
          this.secltableData1.forEach(row => {
            this.elderData1.forEach((item) => {
              if (row.id === item.id) {
                this.$refs.elderTable1.toggleRowSelection(item, true)
              }
            })
          })
        }
      },
    },
  };
</script>

<style lang="scss">
  .treeTableContainer1 {
    .top {
      height: 36px;
      line-height: 36px;
      padding-bottom: 10px;
      overflow: hidden;
      .per{
        float: left;
      }
      .ipt{
        float: right;
      }
      .primaryBtn{
        margin-left: 20px;
        margin-right: 0;
        float: right;
      }
      .el-checkbox {
        line-height: 36px;
      }
      .el-input{
        .el-input__inner{
          height: 36px;
          line-height: 36px;
        }
      }
    }

    .treeTableTheader {
      ul {
        height: 36px;
        background: rgba(155, 187, 250, 0.3);
        border-bottom: 2px solid #2662DC;

        li {
          float: left;
          width: 150px;
          line-height: 36px;
          padding: 0 10px;

          &:first-child {
            width: 266px;
            padding-left: 20px;
            padding-right: 0;
          }

          &:nth-child(2) {
            width: 150px;
          }

          &:nth-child(3) {
            width: 350px;
          }

          // &:nth-child(4){
          //   width:350px;
          // }
        }
      }
    }

    .treeTableTbody {
      .borderTable {
        &::before {
          display: none;
        }
          th {
            background: #F2F2F2;
            font-weight: 500;
            font-size: 15px;

            &:nth-child(1) {
              .cell {
                padding-left: 14px;
              }
            }
          }
          td {
            border-bottom: 1px solid #E6E6E6;
            font-size: 14px;

            .cell {

              .el-button--small,
              .el-button--small.is-round {
                padding: 4px 6px;
              }
            }
          }
        .el-table__fixed-right::before {
          display: none;
        }

        .el-table-column--selection {
          border-right: 1px solid #E6E6E6;
          box-shadow: 2px 0 3px -1px #E6E6E6; //右边阴影
          z-index: 999;
        }
      }
    }

    .pageWrap {
      padding: 10px 0 20px;

      .el-select {
        .el-input {
          .el-select__caret {
            line-height: 28px !important;
          }
        }
      }
    }
  }
</style>